var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5236 8.33319L8.5205 12.347C9.05508 12.7034 9.32242 12.8816 9.61133 12.9509C9.86658 13.012 10.1327 13.012 10.3881 12.9509C10.677 12.8816 10.9443 12.7034 11.4789 12.347L17.4758 8.33319M8.58175 3.39052L3.74845 6.42592C3.29267 6.71214 3.06479 6.85526 2.8995 7.04873C2.75321 7.21996 2.64313 7.41907 2.57592 7.63403C2.5 7.87689 2.5 8.14598 2.5 8.68419V13.9999C2.5 14.9333 2.5 15.4 2.68166 15.7565C2.84144 16.0701 3.09641 16.3251 3.41002 16.4849C3.76653 16.6665 4.23324 16.6665 5.16667 16.6665H14.8333C15.7667 16.6665 16.2335 16.6665 16.59 16.4849C16.9036 16.3251 17.1586 16.0701 17.3183 15.7565C17.5 15.4 17.5 14.9333 17.5 13.9999V8.68419C17.5 8.14598 17.5 7.87689 17.4241 7.63403C17.3568 7.41907 17.2468 7.21996 17.1005 7.04873C16.9352 6.85526 16.7073 6.71214 16.2516 6.42592L11.4182 3.39052C10.9038 3.06749 10.6467 2.90598 10.3707 2.84303C10.1267 2.78735 9.87333 2.78735 9.62925 2.84303C9.35333 2.90598 9.09617 3.06749 8.58175 3.39052Z",
    stroke: "#5B5B5B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.23e798decdc438d59dfac40f567d7d55.svg";
export { ForwardRef as ReactComponent };